import styled from "styled-components";

export const Button = styled.span`
    margin-top:20px;
    display: block;
    width:  200px;
    padding: 15px 24px;
    background-color: rgb(255, 60, 71);
    color: white;
    font-size:20px;    
    border-radius:20px;
    cursor:pointer;
    `;